import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IImportSettingsMcbSftp } from './import-settings-mcb-sftp.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ImportSettingsMcbSftpService {

  constructor(
    private http: HttpClient,
  ) { }

  public get(bankAccountId: number): Observable<IImportSettingsMcbSftp> {
    const url = `${environment.api}/v2/bank-accounts/${bankAccountId}/import-settings/mcb-sftp`;
    return this.http.get<IImportSettingsMcbSftp>(url);
  }

  public save(bankAccountId: number, settings: IImportSettingsMcbSftp): Promise<void> {
    const url = `${environment.api}/v2/bank-accounts/${bankAccountId}/import-settings/mcb-sftp`;
    return this.http.post<void>(url, settings).toPromise();
  }

}
